//
//
//
//
//
//
export default {
  name: 'border',
  props: {
    direction: {
      type: String,
      default: 'left'
    },
    width: {
      type: String,
      default: '430px'
    }
  }
};